{
  "nav": {
    "classes": "Classes"
  },
  "classes": {
    "title": "Classes",
    "subtitle": "Classes and fixed time slots. Real sessions live on the Dashboard.",
    "tabs": {
      "list": "List",
      "grid": "Weekly schedule"
    },
    "newClass": "New class",
    "empty": {
      "title": "No classes yet.",
      "body": "Create a class to place students — the app generates sessions and attendance automatically."
    },
    "filters": {
      "allTeachers": "All teachers",
      "allSubjects": "All subjects",
      "showEndedChip": "Also showing ended",
      "showArchivedChip": "Also showing archived"
    },
    "pageMenu": {
      "showEnded": "Ended",
      "showArchived": "Archived",
      "classModeSettings": "How classes are organized…"
    },
    "list": {
      "columnClass": "Class",
      "columnSubject": "Subject",
      "columnSchedule": "Weekly schedule",
      "columnTeacher": "Teacher",
      "columnCapacity": "Roster",
      "columnStartsOn": "Starts",
      "full": "Full {{count}}",
      "statusUpcoming": "Starting soon",
      "statusEnded": "Ended · {{from}} → {{to}}",
      "loadError": "Could not load the class list.",
      "loading": "Loading...",
      "filterEmptyTitle": "No classes match this filter"
    },
    "toast": {
      "created": "Class created",
      "updated": "Class updated",
      "archived": "Class archived",
      "archiveError": "Could not archive the class",
      "unarchived": "Class restored",
      "unarchiveError": "Could not restore the class",
      "memberSlotsUpdated": "Khung giờ updated",
      "memberSlotsError": "Could not update khung giờ",
      "memberRemoved": "Removed from class",
      "memberRemoveError": "Could not remove from class"
    }
  },
  "classDetail": {
    "header": {
      "addMembers": "Add students",
      "editClass": "Edit class",
      "endClass": "End class",
      "archive": "Archive",
      "unarchive": "Restore",
      "attendanceMonth": "Monthly attendance",
      "window": "Starts {{start}} → {{end}}",
      "windowOpen": "Starts {{start}}, runs indefinitely",
      "roster": "Roster {{count}}",
      "ended": "Ended {{date}}",
      "upcoming": "Starting soon {{date}}"
    },
    "roster": {
      "title": "Students",
      "emptyTitle": "No students yet.",
      "emptyBody": "Add from the list, create new, or import from an Excel file for this class.",
      "columnStudent": "Student",
      "columnSlots": "Time slots",
      "columnStart": "Started",
      "columnFee": "Tuition",
      "termUnit": "sessions",
      "partial": "{{joined}}/{{total}} time slots",
      "editSlots": "Edit time slots",
      "editSlotsAria": "Edit {{name}}'s time slots",
      "openStudent": "Open student page",
      "removeFromClass": "Remove from class",
      "rowMenuAria": "Actions for {{name}}",
      "pausedNote": "placement kept on hold"
    },
    "slots": {
      "title": "Time slots",
      "duration": "{{minutes}} min",
      "editAria": "Edit this time slot",
      "next": "Next session: {{day}} {{date}}",
      "nextToday": "Today {{time}}, not marked yet"
    },
    "review": {
      "title": "Monthly reviews",
      "monthTitle": "Month {{month}}",
      "progress": "{{done}}/{{total}} reviewed",
      "hint": "Write after the last session of the month — AI drafts from the notes already logged.",
      "link": "Open monthly reviews · {{subject}}"
    },
    "popover": {
      "title": "{{name}}'s time slots",
      "fromDate": "from {{date}}",
      "newTag": "New",
      "fromLabel": "From",
      "consequence": "Unticking a time slot: its future sessions no longer include this student; sessions already marked stay as they are.",
      "cancel": "Cancel",
      "save": "Save"
    },
    "endDialog": {
      "title": "End this class?",
      "consequence": "From this date the class stops generating sessions. Future unmarked sessions after this date are deleted; history is kept.",
      "dateLabel": "End date",
      "cancel": "Cancel",
      "confirm": "End class",
      "error": "Could not end the class"
    },
    "archiveConfirm": {
      "title": "Archive this class?",
      "body": "Archives the class and all of its time slots. Future unmarked sessions are deleted; history is kept.",
      "action": "Archive"
    },
    "removeConfirm": {
      "title": "Remove from class?",
      "body": "Remove {{name}} from the class: future sessions of every time slot in the class no longer include this student; sessions already marked stay as they are.",
      "action": "Remove from class"
    }
  },
  "classForm": {
    "createTitle": "New class",
    "editTitle": "Edit class",
    "createDescriptionCohort": "A class groups weekly time slots. Add students and pricing after it's created.",
    "editDescription": "Changes only apply to future sessions — sessions that already happened are unaffected. A class is locked to its subject; to use a different subject, create a new class.",
    "a11yTitle": "Class form",
    "genericError": "Could not save the class",
    "sectionInfo": "Class info",
    "name": "Class name",
    "nameOptional": "Class name (optional)",
    "namePlaceholderCohort": "E.g. Math 8, Tue/Thu evenings",
    "namePlaceholderDerived": "Leave blank to show {{preview}}",
    "subject": "Subject",
    "teacher": "Teacher",
    "teacherResponsible": "Teacher in charge",
    "branch": "Branch",
    "branchNone": "No branch",
    "room": "Room / note (optional)",
    "roomUnchangedHint": "Leave blank to keep the current room.",
    "capacity": "Max class size",
    "capacityHint": "Leave blank for no limit; 1 means one-on-one.",
    "sectionSchedule": "Weekly schedule",
    "startTime": "Start time",
    "duration": "Duration (min)",
    "perDayToggle": "Different time or teacher per day",
    "perDayDay": "Day",
    "perDayHour": "Hour",
    "perDayMinute": "Min",
    "perDayTeacher": "Teacher",
    "teacherLockedTooltip": "A time slot is locked to its teacher. For a different teacher, remove this time slot and add a new one.",
    "removeDayConsequence": "Removing {{day}} {{time}}: future un-marked sessions will be deleted, history is kept. {{count}} students are in this time slot.",
    "undo": "Undo",
    "startsOn": "Start date",
    "startsOnHint": "Already been teaching this class? Pick the real first session date — the app backfills past sessions to mark.",
    "endsOn": "End date",
    "endsOnOptional": "(optional)",
    "endsOnHintCreate": "Leave blank if the class runs indefinitely. After this date the class stops generating sessions; history is kept.",
    "endsOnHintEdit": "After this date the class reads \"Ended\".",
    "addEndDate": "Add an end date",
    "sectionPricing": "Default fee for new students",
    "pricingSessionMonthlyLabel": "Per session",
    "pricingSessionMonthlyDesc": "Counts attended sessions, reconciled at closing",
    "pricingSessionTermLabel": "Per term",
    "pricingSessionTermDesc": "Paid upfront for N sessions",
    "pricingMonthlyFlatLabel": "Fixed monthly",
    "pricingMonthlyFlatDesc": "One flat amount per month, billed in advance",
    "ratePerSession": "Fee per session (₫)",
    "monthlyRate": "Monthly fee (₫)",
    "termSize": "Sessions per term",
    "chargeAbsent": "Unexcused absence still bills",
    "pricingHint": "Only used as a prefill when adding students. Real pricing lives on each student's own enrollment and can be edited individually.",
    "sectionColor": "Colour on the calendar",
    "colorAuto": "Automatic",
    "colorTooltip": "Automatic: a class with two or more time slots gets a colour so they're recognizable together on the calendar.",
    "colorSwatchLabel": "Colour {{n}}",
    "colorChosen": "Colour chosen",
    "rateFromSubject": "{{rate}} (subject's default)",
    "pricingColorSummaryLabel": "Default fee and calendar colour",
    "cancel": "Cancel",
    "submitCreate": "Create class",
    "submitEdit": "Save",
    "discardTitle": "Discard changes?",
    "discardBody": "Unsaved changes will be lost.",
    "discardConfirm": "Discard",
    "discardCancel": "Keep editing",
    "loading": "Loading..."
  },
  "addMembers": {
    "title": "Add students to {{class}}",
    "confirmTitle": "Confirm adding to {{class}}",
    "defaultFeeNote": "default fee {{rate}}",
    "loading": "Loading...",
    "cancel": "Cancel",
    "continue": "Continue",
    "back": "Back",
    "unit": {
      "month": "month",
      "session": "session"
    },
    "tabs": {
      "create": "Create new",
      "pick": "Pick from list",
      "import": "Import from Excel"
    },
    "create": {
      "name": "Full name",
      "namePlaceholder": "e.g. Nguyễn Văn An",
      "nickname": "Nickname",
      "nicknamePlaceholder": "e.g. Bơ",
      "dob": "Date of birth",
      "payer": "Payer",
      "payerPlaceholder": "Payer name",
      "phone": "Phone / Zalo",
      "payerSearchPlaceholder": "Search payer...",
      "payerEmpty": "No match",
      "newPayerLink": "Enter a new payer",
      "existingPayerLink": "Pick an existing payer",
      "selfPayLink": "Student pays for themselves",
      "selfPayNote": "Student pays for themselves (adult)",
      "dupFound": "Already exists: {{name}}, client {{payer}}",
      "weakDupFound": "Might match {{name}}, client {{payer}}",
      "dupStudying": "currently learning {{subjects}}",
      "useExisting": "Use existing student",
      "createNewInstead": "Create new",
      "useExistingHint": "Use existing student: only creates the {{subject}} enrollment and adds them to the class, the profile is unchanged.",
      "removeRow": "Remove this row",
      "addRow": "Add row",
      "footerCount": "{{newCount}} new students · {{existingCount}} using an existing profile"
    },
    "pick": {
      "searchPlaceholder": "Diacritic-blind · search by name",
      "resultCount": "{{count}} results",
      "emptyPrompt": "Type a name to search",
      "noResults": "No students found",
      "alreadyInClass": "Already in {{name}}",
      "hasEnrollment": "Already enrolled in {{subject}} · {{rate}}/{{unit}}",
      "pausedEnrollment": "Enrollment in {{subject}} is paused",
      "noEnrollment": "No {{subject}} enrollment yet",
      "selectedCount": "{{count}} students selected"
    },
    "confirm": {
      "subtitle": "{{count}} students · fee and khung giờ can be edited per student",
      "startDate": "Start date",
      "pricingLabel": "Pricing for the whole group",
      "pricing": {
        "SESSION_MONTHLY": "Per session",
        "SESSION_TERM": "Per term",
        "MONTHLY_FLAT": "Flat monthly"
      },
      "termSize": "Sessions per term",
      "termSizeRequired": "Enter the sessions per term to continue.",
      "colStudent": "Student",
      "colFeeMonth": "Fee / month",
      "colFeeSession": "Fee / session",
      "colSlots": "khung giờ",
      "colNote": "Note",
      "note": {
        "paused": "Currently paused — resume it first, then add to a class",
        "pricingLocked": "Already enrolled in {{subject}} under a different pricing type, keeping {{rate}}/{{unit}}",
        "keepRate": "Already enrolled in {{subject}}, keeping {{rate}}/{{unit}}.",
        "existingPartial": "Using an existing profile. Only some khung giờ selected; per-session pricing bills only sessions attended.",
        "existingProfile": "Using an existing profile. New {{subject}} enrollment on the class's own defaults.",
        "newDefault": "New {{subject}} enrollment on the class's own defaults."
      },
      "duplicateError": "A student is duplicated in the list — check the rows before adding.",
      "excludedNote": "{{count}} student(s) have a paused enrollment and are not part of this batch.",
      "repriceHint": "A fee changed here follows the fee-change rule: it applies to anything not invoiced yet.",
      "termFooterNote": "Starting the term and the up-front invoice still happen on the student's own page.",
      "editRate": "Edit fee",
      "submitting": "Adding...",
      "submit": "Add {{count}} students",
      "successToast": "Added {{count}} students to {{class}}",
      "retryToast": "The system is busy, please try again.",
      "genericError": "Could not add students"
    }
  },
  "grid": {
    "note": "This is the fixed weekly grid, not a real session. See real sessions and attendance on the",
    "jumpToDay": "Jump to day"
  },
  "timetable": {
    "allTeachers": "All teachers",
    "empty": "No slots yet",
    "emptyArchived": "No archived slots",
    "emptyArchivedHint": "Archived slots live here — you can restore them at any time.",
    "emptyHint": "Create a fixed weekly slot to place students and auto-generate sessions and attendance.",
    "today": "Today",
    "newSlot": "New slot"
  },
  "slot": {
    "create": "Create slot",
    "edit": "Edit slot",
    "teacher": "Teacher",
    "teacherOwner": "Teacher in charge",
    "teacherOwnerHint": "Shown on the class card and the timetable filter. Doesn't affect pay — every Lead teacher is paid the same way.",
    "teacherList": "Teachers",
    "addTeacher": "Add teacher",
    "removeTeacher": "Remove {{name}} from class",
    "roleChinh": "Lead",
    "roleTroGiang": "Assistant",
    "moreTeachers": "+{{count}} teachers",
    "moreTeachers_one": "+1 teacher",
    "subject": "Subject",
    "branch": "Branch",
    "branchNone": "No branch",
    "branchArchived": "{{name}} (archived)",
    "day": "Day",
    "startTime": "Time",
    "duration": "Duration (min)",
    "capacity": "Max capacity",
    "capacityOfClass": "Max capacity {{count}} belongs to the whole class.",
    "capacityOfClassLink": "Edit on the class page",
    "name": "Class name (optional)",
    "members": "Students",
    "archive": "Archive",
    "archiveConfirm": {
      "title": "Archive this slot?",
      "body": "Future un-marked sessions will be deleted; history is kept.",
      "action": "Archive"
    },
    "restore": "Restore",
    "restored": "Slot restored",
    "minutes": "min",
    "officialMembers": "Enrolled students",
    "noMembers": "No students yet",
    "pausedSection": "Paused",
    "pausedTag": "paused",
    "showActive": "Active",
    "showArchived": "Archived",
    "cancel": "Cancel",
    "submit": "Save",
    "editDescription": "Changes only apply to future sessions — sessions that already happened are unaffected. A slot is locked to its subject and teacher in charge; to use a different subject or teacher, create a new slot.",
    "addMember": "Add student",
    "addMemberPlaceholder": "Select a student...",
    "removeAria": "Remove {{name}} from class",
    "removeConfirm": {
      "title": "Remove from class?",
      "titleTemplate": "Remove from template?",
      "bodyReality": "Remove {{name}} from this recurring time slot — future sessions of this slot will no longer include this student. Already-marked sessions are unchanged.",
      "bodyTemplate": "Remove {{name}} from this slot in the template — the real schedule is unchanged.",
      "action": "Remove from class"
    }
  },
  "assign": {
    "title": "Assign class",
    "recurringTitle": "{{subject}} classes open",
    "recurringHint": "Meets every week on the class's own schedule",
    "startDateLabel": "Start date",
    "startDateHint": "Applies to the class you assign below. Pick a past date to include sessions that already happened (so you can take attendance).",
    "joinFrom": "Assign to class · from {{date}}",
    "overCapacity": "Over capacity — can still assign",
    "joined": "Assigned",
    "leave": "Remove from class",
    "onlySomeSlots": "Only some time slots",
    "onlySomeSlotsNote": "Billed by actual session, so attending only Mon means paying only for Mon.",
    "createClass": "Create new class",
    "emptyClasses": "No {{subject}} classes yet",
    "classPrefix": "{{name}} class",
    "classPartial": "{{joined}}/{{total}} time slots",
    "membersMore": "+{{count}}",
    "notAssigned": "Not assigned to a slot yet",
    "oneOffTitle": "One-off session (makeup / extra)",
    "oneOffHint": "A single session, not recurring"
  },
  "days": {
    "1": "Mon",
    "2": "Tue",
    "3": "Wed",
    "4": "Thu",
    "5": "Fri",
    "6": "Sat",
    "7": "Sun"
  },
  "moveMode": {
    "toggleOn": "Move students",
    "toggleOff": "Exit move mode",
    "hintStart": "Start by ticking students in one slot — only then can you drag or pick a target.",
    "hintTarget": "Drag the group onto a target slot, or pick one in the bar below.",
    "pausedNotice": "{{count}} paused student(s) not shown here — move them from the student page.",
    "sourceBadge": "Source",
    "targetBadge": "Target",
    "previewChipTitle": "Will move into this slot on confirm",
    "otherSubject": "Different subject",
    "bar": {
      "count": "Move {{count}} students",
      "pickTarget": "Choose target slot",
      "confirm": "Confirm",
      "confirming": "Moving...",
      "cancel": "Cancel",
      "ariaLabel": "Move students to another slot"
    },
    "picker": {
      "title": "Choose target slot",
      "description": "Only same-subject, active slots other than the source are shown.",
      "empty": "No eligible slot to move to."
    },
    "dragBadge": "{{count}} students",
    "hintTargetMobile": "Pick the target class in the bar below."
  },
  "template": {
    "label": "Schedule template",
    "menuLabel": "Template options",
    "createItem": "+ Create template…",
    "appliedNote": "Applied {{date}}",
    "liveNote": "A schedule template only holds class placements: which students go into which slots when applied. Adding/editing/archiving slots always takes effect on the live timetable.",
    "apply": "Apply…",
    "rename": "Rename template",
    "delete": "Delete template",
    "exit": "Exit",
    "loadError": "Could not load the template — reverted to Reality",
    "backupPrefix": "Backup",
    "inactiveChip": "Student has left — will be skipped on apply",
    "orphanPopover": {
      "aria": "Why will this slot be skipped when applying?",
      "label": "Attention",
      "body": "This slot has been archived in the current timetable — students placed here will be skipped when applying.",
      "restoreAction": "Restore slot",
      "restoreConfirm": {
        "title": "Restore this slot?",
        "body": "The slot will become active again in the current timetable and start generating sessions as before."
      }
    },
    "create": {
      "title": "Create schedule template",
      "nameLabel": "Template name",
      "namePlaceholder": "E.g. Summer schedule / School-year schedule",
      "modeLabel": "Start from",
      "empty": "Empty",
      "copy": "Copy current class assignment",
      "submit": "Create template"
    },
    "renameDialog": {
      "title": "Rename template",
      "submit": "Save"
    },
    "deleteConfirm": {
      "title": "Delete this template?",
      "body": "Only the draft is deleted — the real class assignment is unaffected.",
      "action": "Delete template"
    },
    "applyDialog": {
      "title": "Apply schedule template",
      "loading": "Working out the changes…",
      "counts": "{{joins}} joining · {{leaves}} leaving · {{unchanged}} unchanged",
      "orphanWarning": "Slot {{label}} is archived — {{n}} student(s) in the template will not be placed",
      "backupNote": "Your current class assignment will be backed up as a new template — apply that template again to go back.",
      "guidance": "Applying takes effect immediately. Best pressed after the month's last class — ideally the evening of 8/31 or the morning of 9/1.",
      "blocked": "Month {{m}} is not closed yet — close it before applying, so last month's numbers stay put.",
      "goClose": "Go close the month",
      "cancel": "Cancel",
      "confirm": "Apply",
      "applying": "Applying…",
      "toast": "Applied: {{joined}} joined, {{left}} left",
      "toastWithBackup": "Applied. Backup: {{name}}",
      "noChanges": "This template already matches reality — nothing to change."
    }
  },
  "sessions": {
    "status": {
      "SCHEDULED": "Scheduled",
      "COMPLETED": "Done",
      "CANCELLED": "Cancelled"
    }
  },
  "oneOff": {
    "date": "Date",
    "time": "Time",
    "duration": "Duration (min)",
    "add": "Add one-off session"
  },
  "session": {
    "detail": "Session detail",
    "teacher": "Teacher in charge",
    "changeTeacher": "Change teacher",
    "moreTeachers": "+{{count}} teachers",
    "moreTeachers_one": "+1 teacher",
    "subject": "Subject",
    "time": "Time",
    "participants": "Students in session",
    "addStudent": "Add student",
    "addSearchPlaceholder": "Search students...",
    "addEmpty": "No student found",
    "addHint": "Adds the student to this session only (makeup) — not to the recurring weekly schedule.",
    "removeStudent": "Remove",
    "move": "Move slot",
    "reschedule": "Reschedule",
    "cancel": "Cancel session",
    "note": "Note",
    "noteFor": "Note for {{name}}",
    "back": "Back",
    "teacherAdhocPopover": {
      "body": "This teacher isn't part of the slot's fixed schedule — they're only teaching this session.",
      "billing": "The session still counts toward pay as normal."
    }
  },
  "attendance": {
    "title": "Attendance",
    "present": "Present",
    "absent": "Absent",
    "excused": "Excused",
    "discard": "Discard",
    "markAllPresent": "All present",
    "save": "Save attendance",
    "saving": "Saving...",
    "notYet": "Not time yet",
    "upcoming": "Upcoming",
    "done": "Attendance taken",
    "note": "Reason (if excused)",
    "attended": "attended",
    "sessions": "sessions",
    "adhoc": "Ad-hoc",
    "adhocPopover": {
      "body": "This student was added to this session only — they are not part of the class’s fixed schedule and it does not repeat next week.",
      "billing": "Attendance still counts as normal; per-session students are billed for it at the next chốt sổ.",
      "aria": "Why is {{name}} ad-hoc?"
    },
    "removeTitle": "Remove student from this session?",
    "removeDescription": "Only removes from this one-off/makeup session; does not affect the fixed schedule.",
    "removeCancel": "Cancel",
    "removeConfirm": "Remove",
    "officialRemoveTitle": "Can't remove an official student",
    "officialRemoveDescription": "Official students (from the fixed schedule) are managed in Class Assignment. Only ad-hoc students (makeup / swap) can be removed here. If the student is absent this session, mark them Excused.",
    "close": "Close",
    "quotaWarning": "Already used all {{limit}} excused absences this month — should this one count as absent?",
    "madeUpSuffix": "(made up {{count}})",
    "quotaChip": "Excused {{quota}}",
    "quotaChipAria": "Explain {{name}}'s excused absences",
    "modeBadge": {
      "SESSION_MONTHLY": "Per session",
      "SESSION_TERM": "Term",
      "MONTHLY_FLAT": "Monthly",
      "termWithPosition": "Term {{termIndex}}/{{termSize}}",
      "aria": "How {{name}} pays: {{badge}}"
    },
    "modePopover": {
      "position": "Today is session {{termIndex}} of a {{termSize}}-session term — {{remaining}} left.",
      "positionLast": "Today is session {{termIndex}} of a {{termSize}}-session term — the last one of the term.",
      "positionOverrun": "Today is session {{termIndex}} of a {{termSize}}-session term — {{over}} over the block.",
      "noOpenTerm": "The term is used up — renew it on the student's page."
    },
    "quotaPopover": {
      "madeUpRule": "If the student makes the class up within the month, the excused absence is refunded.",
      "withLimit": "This month {{name}} has {{used}} excused absence(s) out of a {{limit}} limit.",
      "withLimitMadeUp": "This month {{name}} has {{used}} excused absence(s) out of a {{limit}} limit. {{madeUp}} were made up in another slot and refunded to the quota.",
      "noLimit": "This month {{name}} has {{used}} excused absence(s).",
      "noLimitMadeUp": "This month {{name}} has {{used}} excused absence(s). {{madeUp}} were made up in another slot and refunded to the quota."
    },
    "chargeNote": {
      "chargedMonthly": "This absence will be billed.",
      "chargedTerm": "This absence will count toward the term's sessions.",
      "notCharged": "This absence will not be billed.",
      "flat": "No effect on tuition (flat monthly package)."
    },
    "locked": "Month {{month}} is closed — reopen the month to change attendance.",
    "lockedNoMonth": "The month is closed — reopen it to change attendance.",
    "progress": "{{marked}}/{{total}} marked",
    "barAriaLabel": "Save attendance for this session"
  },
  "attendanceGrid": {
    "searchPlaceholder": "Search student...",
    "showAll": "Show all",
    "showExceptions": "Exceptions only",
    "student": "Student",
    "excused": "Exc.",
    "madeUp": "Makeup",
    "absent": "Abs.",
    "pending": "Missing",
    "empty": "No sessions this month",
    "allClear": "All attendance is marked for {{month}} 🎉",
    "noMatch": "No matching students",
    "markCta": "Mark attendance",
    "markCellLabel": "Mark attendance for {{date}}",
    "openCta": "Open session",
    "openCellLabel": "Open session of {{date}}",
    "pendingCountLabel": "{{count}} un-marked session(s)"
  },
  "monthGrid": {
    "title": "Monthly attendance",
    "subtitle": "The whole class as ✓/✗ — tap a cell to open that session.",
    "pickMonth": "Pick a month to view",
    "thisMonth": "This month",
    "searchPlaceholder": "Search by name or nickname",
    "gridTitle": "Month {{month}}",
    "onlyStudent": "Only: {{name}}",
    "onlyStudentClear": "Clear student filter",
    "emptyMonth": "No sessions in {{month}}.",
    "emptyFilteredTitle": "No students match these filters",
    "emptyFilteredBody": "Try removing a filter, or picking a different month.",
    "loadError": "Could not load attendance."
  }
}
